<script setup>
import { useChatStore } from '../stores/chat';
import Chat from './Chat.vue';
import Resource from './Resource.vue';

const { labels } = window.DATAGENT_PLUGIN_CHAT;
const chatStore = useChatStore();

// Function to change active tab
const setActiveTab = (tab) => {
  chatStore.setActiveChatTab(tab);
};

// Menus
const menus = [
  {
    id: 'chat',
    label: labels.chat,
    icon: 'fas fa-comment',
    component: Chat,
  },
  {
    id: 'resources',
    label: labels.resources,
    icon: 'fas fa-puzzle-piece',
    component: Resource,
  },
];
</script>

<template>
  <div>
    <!-- Tab Navigation -->
    <div class="da:border-b da:border-gray-200">
      <nav class="da:flex da:space-x-2" aria-label="Tabs">
        <template v-for="menu in menus" :key="menu.id">
          <div
            @click="setActiveTab(menu.id)"
            :class="[
              chatStore.activeChatTab === menu.id
                ? 'da:border-[#4CB21A] da:text-[#4CB21A]'
                : 'da:border-transparent da:text-gray-500 da:hover:text-gray-700 da:hover:border-gray-300',
              'da:cursor-pointer da:whitespace-nowrap da:py-4 da:px-6 da:border-b-3 da:font-medium da:text-sm da:focus:outline-none',
            ]"
            style=""
          >
            <i :class="menu.icon" class="da:mr-2"></i>
            <span>{{ menu.label }}</span>
          </div>
        </template>
      </nav>
    </div>

    <!-- Tab Content -->
    <div>
      <template v-for="menu in menus" :key="menu.id">
        <div v-show="chatStore.activeChatTab === menu.id">
          <component :is="menu.component"></component>
        </div>
      </template>
    </div>
  </div>
</template>
